import { useLanguage } from '../context/LanguageContext';

const LOGO = 'https://customer-assets.emergentagent.com/job_04606eda-c805-4e3a-af14-63242db4ed24/artifacts/q6gaf0lc_endless%20knot%20symbol%207.png';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer data-testid="footer" className="bg-obsidian py-20 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">

        {/* Top: logo + nav */}
        <div
          className="flex flex-col md:flex-row items-start md:items-center justify-between gap-12 pb-14 border-b"
          style={{ borderColor: 'rgba(255,255,255,0.08)' }}
        >
          <div className="flex items-center gap-5">
            <div className="w-12 h-12 flex-shrink-0">
              <img src={LOGO} alt="Geranium Bohemicum" className="w-full h-full object-contain" loading="lazy" />
            </div>
            <div>
              <p className="font-heading font-light text-white tracking-[0.2em] text-sm">
                GERANIUM BOHEMICUM
              </p>
              <p className="font-body text-xs text-white/40 tracking-widest uppercase mt-1">
                {t.footer.brandLocation}
              </p>
            </div>
          </div>

          <nav className="flex flex-wrap gap-x-8 gap-y-4">
            {t.footer.links.map((l) => (
              <a
                key={l.label}
                href={l.href}
                data-testid={`footer-link-${l.href.replace('#', '')}`}
                className="font-body text-xs tracking-widest uppercase text-white/50 hover:text-white transition-colors duration-300"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>

        {/* Bottom: contact info + copyright */}
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-8 pt-10">
          <div className="space-y-2">
            <a
              href="mailto:gospodinovioan@gmail.com"
              data-testid="footer-email"
              className="block font-body text-sm text-white/50 hover:text-white transition-colors duration-300"
            >
              gospodinovioan@gmail.com
            </a>
            <a
              href="tel:+359884699193"
              data-testid="footer-phone"
              className="block font-body text-sm text-white/50 hover:text-white transition-colors duration-300"
            >
              +359 884 699 193
            </a>
            <p className="font-body text-xs text-white/30 mt-1">
              {t.footer.proprietor}
            </p>
          </div>

          <p className="font-body text-xs tracking-widest uppercase text-white/25">
            {t.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
